import { NonSortableHeaderCell } from "../../../../Layout/SortedList";
import React from "react";
import i18n from "i18next";

const SubListHeader = () => {
  return (
    <div role="row" tabIndex="0" className="sorted-list__row-header --sub">
      <NonSortableHeaderCell className="--first --x4" keyName="loadId" label={`${i18n.t("loads.load")} # - ${i18n.t("loads.mill")}`} />
      <NonSortableHeaderCell className="--x3" keyName="status" label={i18n.t("loads.deliveryStatus")} />
      <NonSortableHeaderCell className="--x3" keyName="quantityPlanned" label={i18n.t("loads.planning")} />
      <NonSortableHeaderCell className="--right --x2" keyName="quantityProduced" label={i18n.t("loads.produced")} />
      <NonSortableHeaderCell className="--right --x2" keyName="quantityShipped" label={i18n.t("loads.shipped")} />
      <NonSortableHeaderCell className="--x5" keyName="deliveryInfo" label={i18n.t("loads.shipmentStatus")} />
      <NonSortableHeaderCell className="--center --x1" keyName="deliveredDate" />
    </div>
  );
};

export default SubListHeader;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Loads/SubListHeader.js